import { render, staticRenderFns } from "./booking-status-label.vue?vue&type=template&id=264c277a&"
import script from "./booking-status-label.vue?vue&type=script&lang=js&"
export * from "./booking-status-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports